import toast from "react-hot-toast";

export const handleAdminLogout = () => {
  localStorage.removeItem("USER");
  localStorage.removeItem("access-token");
  localStorage.removeItem("currency");

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

export const copyToClipboard = async (text: string) => {
  if (!text) return false;

  try {
    await navigator.clipboard.writeText(text);

    toast.success("Copied to clipboard");

    return true;
  } catch (err) {
    console.error("Copy failed:", err);

    toast.error("Copied to clipboard failed");

    return false;
  }
};

export const downloadTemplate = (path: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = path;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
};

export const downloadTxtFile = (fileName: string, values: string[]) => {
  const content = values.join("\n");

  const blob = new Blob([content], {
    type: "text/plain;charset=utf-8",
  });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.txt`;
  a.click();

  URL.revokeObjectURL(url);
};
